import React, {Component} from "react";
import {Growl} from "primereact/growl";
import {validateNumberIntegersDecimals} from "../../../utils/formatters/Numbers";
import {CorporateActionService} from "../../../service/admin/corporateAction/CorporateActionService";
import {CatalogService} from "../../../service/catalog/CatalogService";
import ExchangeView from "./ExchangeView";

export default class ExchangeContainer extends Component {
    /**
     * Constructor de la clase ExchangeContainer
     * en este se inicializan los valores iniciales de la clase.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);

        this.corporateActionService = new CorporateActionService();
        this.catalogService = new CatalogService();
        this.getInstruments = this.getInstruments.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            screenName: this.props.location.state.screenName,
            dataCorporateAction: this.props.location.state.corporateAction,
            isLoading: true,
            ratio: '1',
            instruments: this.getInstruments(),
        };

        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.applyCorporateAction = this.applyCorporateAction.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que consume a CatalogService y obtiene el catálogo de aforos
     * de la institución, lo coloca en una variable del state y también
     * coloca el objeto que trae el elemento a editar.
     */
    getInstruments() {
        this.loading();
        this.catalogService.getCatalogInstrument()
            .then(instruments => this.setState({
                instruments: instruments.map(this.getFullInstrument),
                instrumentObject: '',
                isLoading: false,
            }));
    }

    /**
     * Función que obtiene el string para mostrar en el dropdown de la emisora
     * junta el nombre, serie y tipo valor.
     * @param {object} item El objeto del que se obtiene la información
     * @returns {*} El mismo objeto, pero con el campo fullInstrument lleno
     */

    getFullInstrument(item) {
        let fullInstrument = item['nomEmisora'] + " " + item['serie'] + " " + item['tipoValor'];
        item['fullInstrument'] = fullInstrument;
        return item;
    }

    /**
     * Función  que maneja el cambio en ratio campos de texto.
     * También valida que los campos numéricos sólo acepten x números enteros
     * y dos decimales. El número de enteros a manejar, se indica en el atributo id
     * del campo.
     * @param event
     */
    handleChangeValue(event) {
        const {name, value, id} = event.target;
        let dataCorporateAction = this.state.dataCorporateAction;

        if (name === 'newInstrument') {
            dataCorporateAction['idEmisionNew'] = value['idEmisora'];
            this.setState({
                instrumentObject: value,
                dataCorporateAction: dataCorporateAction
            })
        } else {
            let newValue = validateNumberIntegersDecimals(Number(value), id, 2);
            dataCorporateAction[name] = newValue;
            this.setState({
                [name]: newValue,
                dataCorporateAction: dataCorporateAction
            })
        }
    }

    /**
     * Función que consume el CorporateActionService
     * haciendo una petición al back,
     * para aplicar el ejercicio correspondiente al objeto seleccionado.
     */
    applyCorporateAction() {
        if ((this.state.ratio === '') || (this.state.instrumentObject === '')) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Llenar los campos requeridos.'
            })
        } else {
            let dataCorporateAction = this.state.dataCorporateAction;
            dataCorporateAction['ratio'] = this.state.ratio;
            this.setState({dataCorporateAction: dataCorporateAction});
            this.loading();
            this.corporateActionService.applyCorporateAction(this.state.dataCorporateAction)
                .then(resp => {
                    let message = {};
                    if (resp.message === 'Success') {
                        message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'La acción se ha realizado correctamente',
                        };
                    } else if (resp.error !== '') {
                        message = {
                            severity: 'error',
                            summary: 'Error.',
                            detail: resp.error.replace(/%/g, '')};
                    }
                    this.returnCorporateActionPage(message)
                });
        }

    }

    /**
     * Función que regresa a la pantalla de CorporateAction
     */
    returnCorporateActionPage = (message) => {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {isLoading, dataCorporateAction, ratio, instrumentObject, instruments} = this.state;

        return <ExchangeView messagesGrowl={messagesGrowl}
                             isLoading={isLoading}
                             dataCorporateAction={dataCorporateAction}
                             ratio={ratio}
                             instrumentObject={instrumentObject}
                             instruments={instruments}
                             returnCorporateActionPage={this.returnCorporateActionPage}
                             handleChangeValue={this.handleChangeValue}
                             applyCorporateAction={this.applyCorporateAction}
        />
    }
};